import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  TrendingUp, MessageSquare, Star, 
  Loader2, Plus, ArrowUpRight, DollarSign 
} from 'lucide-react';
import { salesService } from '../../services/salesService';
import { useAuth } from '../../context/AuthContext';
import FaceAttendanceWidget from '../../components/FaceAttendanceWidget';

const SalesRepDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await salesService.getLeads();
        setLeads(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary w-10 h-10 opacity-20" /></div>;

  return (
    <div className="space-y-6 text-gray-900">
      <div className="bg-white rounded-card border shadow-soft p-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-black tracking-tight">Personal Pipeline</h1>
          <p className="text-gray-400 font-bold uppercase text-[10px] tracking-widest mt-1">Hello, {user?.full_name}</p>
        </div>
        <button 
          onClick={() => navigate('/sales/new')}
          className="bg-primary text-white px-5 py-2 rounded-xl text-xs font-black uppercase tracking-widest shadow-lg shadow-primary/20"
        >
          + New Lead
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <PersonalCard label="My Active Leads" value={leads.length} icon={<TrendingUp />} />
        <PersonalCard label="My Earnings" value="Check Ledger" icon={<DollarSign />} onClick={() => navigate('/commissions')} />
        <PersonalCard label="Lead List" value="View All" icon={<Star />} onClick={() => navigate('/sales')} />
      </div>

      <FaceAttendanceWidget />

      {/* Recent Activity Mini-list */}
      <div className="bg-white rounded-card border border-gray-100 shadow-soft p-6">
         <h2 className="text-xs font-black text-primary uppercase tracking-[0.2em] mb-4 border-b pb-4">My Recent Leads</h2>
         <div className="space-y-3">
            {leads.slice(0, 3).map(l => (
              <div key={l.id} onClick={() => navigate('/sales/leads/' + l.lead_id)} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                <p className="text-sm font-bold text-gray-900">{l.client_name}</p>
                <p className="text-xs font-black text-primary uppercase">{l.status}</p>
              </div>
            ))}
            {leads.length === 0 && <p className="text-center text-gray-400 py-4 italic text-sm">No leads assigned yet.</p>}
         </div>
      </div>
    </div>
  );
};

const PersonalCard = ({ label, value, icon, onClick }) => (
  <div onClick={onClick} className={'bg-white p-6 rounded-card border border-gray-100 shadow-soft flex flex-col items-center text-center space-y-2 ' + (onClick ? 'cursor-pointer hover:border-primary/30 transition-all' : '')}>
    <div className="p-3 bg-primary/5 text-primary rounded-full mb-2">{icon}</div>
    <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">{label}</p>
    <p className="text-lg font-black text-gray-900">{value}</p>
  </div>
);

export default SalesRepDashboard;